import { render, staticRenderFns } from "./BlwUploadButton.vue?vue&type=template&id=60623280&"
import script from "./BlwUploadButton.vue?vue&type=script&lang=js&"
export * from "./BlwUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./BlwUploadButton.vue?vue&type=style&index=0&id=60623280&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports